import React from 'react';
import {
    Box,
    Flex,
    IconButton,
    Stack,
    useColorMode,
    Container
} from '@chakra-ui/react';
import { MoonIcon, SunIcon } from '@chakra-ui/icons';


export default function Navbar() {
    const { colorMode, toggleColorMode } = useColorMode();
    return (
        <Container maxW={"5xl"} mt={{ base: 5, sm: 5, md: 5, lg: 5 }}>
            <Box px={4}>
                <Flex h={14} alignItems={'center'} justifyContent={'space-between'}>
                    <Box></Box>
                    <Flex alignItems={'center'}>
                        <Stack direction={'row'} spacing={2}>
                            <IconButton variant={"ghost"} onClick={toggleColorMode} isRound={"true"} className="animate__animated animate__fadeIn">
                                {colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
                            </IconButton>
                        </Stack>
                    </Flex>
                </Flex>
            </Box>
        </Container>
    );
}